const en = {
	// Register
	1: 'Register',
	2: 'Please enter your username',
	3: 'The username must start with a letter, contain only letters, underscores, and numbers, and  be between 5 and 10 in length',
	4: 'Please enter your password',
	5: 'The password can only contain letters and numbers, and must be between 6 and 15 in length',
	6: 'Please enter your password again',
	7: 'Please enter your email',
	8: 'The email address must contain the @ character',
	9: 'The left side of the mailbox @ can be letters, underscores, numbers, dot. and small diagonal bar number- except the initial letter',
	10: 'The right side of the mailbox@must have a dot.',
	11: 'Must start with a letter, an underline, a number between @ and. , and except the initial letter, other can be a letter, an underline, a number, a dot. a small diagonal bar number-',
	12: 'Male',
	13: 'Female',
	14: 'Please enter your invite code',
	15: 'Click here to get invite code',
	16: 'Register',
	17: 'Return to login',
	18: 'Click here to leave a message',
	// Index
	19: 'Dear Crazy Tank players, welcome to login',
	20: 'After logging in, you can view your specific information (including record, teams and assets)',
	21: 'There is a slight delay in the display of personal information on the official website. Please refer to the game data',
	22: 'Sign up',
	23: 'Download',
	24: 'Recharge',
	25: 'The Beginners Guide',
	26: 'Game Master Advanced ',
	27: 'Official Forum',
	28: 'Configuration Requirements',
	29: 'Combat Methods',
	30: 'Coming Soon',
	31: 'Item Introduction',
	32: 'Map Introduction',
	33: 'Tank Introduction',
	34: 'News',
	35: 'Notice',
	36: 'Media reviews',
	37: 'Player strategy',
	38: 'Forum hot post',
	39: 'More media reviews',
	40: 'More',
	// Apply
	41: 'Select',
	42: 'Revoke',
	43: 'Approve',
	44: 'Team Name',
	45: 'Leader',
	46: 'Applicant',
	47: 'Level',
	48: 'Create Time',
	49: 'Approved',
	50: 'Rejected',
	51: 'Canceled',
	// Create
	52: 'Create Team(',
	53: ' Coin',
	54: 'Recharge Now',
	55: 'Logout',
	56: 'The team name consists of 3-12 characters',
	57: 'Color',
	58: 'Preview',
	59: 'Create',
	60: 'You have joined a team,if you want to create a team, you must quit or disband the original team first',
	61: 'Create team successed',
	// Detail
	62: 'Delete team',
	63: 'Leave team',
	64: 'Operation',
	65: 'Delete',
	66: 'Alias name',
	67: 'Level',
	68: 'Ranking',
	69: 'Score',
	70: 'Win Rate',
	71: 'Last Login',
	72: 'Team member deleted',
	73: 'Are you sure you want to disband the team?',
	74: 'Hint',
	75: 'Confirm',
	76: 'Cancel',
	77: 'Delete team successed',
	78: 'Canceled',
	79: 'Are you sure you want to quit the team?',
	80: 'You have successfully quit the team',
	// Guild Index
	81: 'Select',
	82: 'Join',
	83: 'Name',
	84: 'Team leader',
	85: 'Number of players',
	86: 'Create Time',
	87: 'Team score',
	88: 'Application has been submitted, please wait for the team leader to review!',
	// Recharge
	89: 'Recharge',
	90: 'How To Recharge',
	91: 'Recharged Amount',
	92: 'Immediately receive ',
	93: 'Cash',
	94: 'For points sponsorship, please contact',
	95: 'Statement of recharge support',
	96: 'Dear friends,',
	97: 'The FortressTank as the last holy land of FortressRed2, we need your support and protection, and we will continue to improve the game is features and fix any problems that may arise.',
	98: 'In order to continue to maintain the operation of the FortressTank, the following expenses are all free sponsorship, hereby declared!',
	99: 'Thank you for your support for the FortressTank in the future!',
	100: 'The Team of FortressTank January 1, 2021',
	101: 'Recharge in progress, please be patient and wait for the results…',
	102: 'close',
	103: 'PayPal recharge',
	104: 'Alipay scan code recharge',
	105: 'QR code recharge',
	106: 'The recharge has been made',
	// MotifyPassword
	107: 'Please enter your old password',
	108: 'Please enter your password',
	109: 'The password can only contain letters and numbers, and must be between 6 and 15 in length',
	110: 'Please enter your password again',
	111: 'Modify',
	112: 'Please enter your email address',
	113: 'Password modification completed',
	// Login
	114: 'User Login',
	115: 'Log in',
	// SideBar
	116: 'Home Page',
	117: 'Team',
	118: 'Team List',
	119: 'Team Detail',
	120: 'Create Team',
	121: 'Join/Apply',
	122: 'Account',
	123: 'Modify Password',
	124: 'Money',
	125: 'WinCount',
	126: 'LoseCount',
	127: 'Account Status',
	// 
	128: 'Click to download',
	129: 'Note',
	130: 'Must be installed C++ Runtime',
	131: 'Please click Paypal button.',
	132: 'Product.',
	133: ' Score',
	134: 'Recharge for Friend',
	135: 'Friend\'s nickname',
	136: 'Please enter your alias name',
	137: 'nickname must be between 1 and 6 in length.',
	138: 'NickName',
	139: 'Modify NickName',
	140: 'NickName Type',
	141: 'Normal(300 Coin)',
	142: 'Special(1500 Coin)',
	143: 'nickname modification completed',
	144: 'check',
	145: 'Register completed',
	146: 'Title',
	147: 'Author',
	148: 'Forgot Password',
	149: 'Next',
	150: 'Sent',
	151: 'Input new password',
	152: 'Search',
	153: 'Find Id',
	154: 'Please enter your new email address',
	155: 'Please enter your new email address again',
	156: 'You write different email address twice',
	157: 'Change email address',
	158: 'Email address modification completed',
	159: 'New email address',
	160: 'Email address',
	161: 'Change guild name',
	162: 'Change guild color',
	163: 'Are you sure you want to change the guild name?',
	164: 'Are you sure you want to change the guild color?',
	165: 'You have changed the guild name successed.',
	166: 'You have changed the guild color successed.',
	167: 'Transference',
	168: 'Are you want to transfer the guild?',
	169: 'You have transfered the guild successed.',
	170: 'Order amout',
	171: 'The minimum is 1,500 coins,increase by 1,500 coins each time',
	172: 'The minimum is 1,000 score,increase by 1,000 score each time',
	173: 'Modify sex',
	174: 'Sex modification completed',
	175: 'Username',
	176: 'Classic',
	177: 'HD',
	178: 'SuperTank',
	179: 'Every rebirth from the ashes is a fresh start, rekindling the memories that once set our blood on fire in those unforgettable years...',
	180: 'SIZE',
	181: 'VERSION',
	182: 'COMPATIBILITY',
	183: 'Introduce',
	184: 'Confirm to download the game installer?',
	185: 'Download',
	186: 'Get code',
	187: 'Please enter your code',
	188: 'Next step',
	189: 'Verification code is 6',
	190: 'Session expired, please log in again.',
	191: 'You have been logged out from another device.',
	// Loading states
	192: 'Processing...',
	193: 'Logging in...',
	194: 'Verifying...',
	195: 'Registering...',
	196: 'Creating...',
	// Validation messages
	197: 'Please enter email',
	198: 'Please enter username and email',
	199: 'Please enter email and verification code',
	200: 'Please enter nickname',
	201: 'Please fill in all information',
	202: 'Passwords do not match',
	203: 'Please enter team name',
	// Empty states
	205: 'No applications',
	206: 'No members',
	207: 'Activated',
	// Discord page
	208: 'Join our Discord community for the latest game news, event announcements, and chat with players worldwide!',
	209: 'Online members',
	210: 'Game announcements',
	211: 'Player chat',
	212: 'Main channels',
	213: '🎮 Join Discord Community',
	// Download page
	214: 'Official | Safe & clean | Direct install APK',
	215: 'Also available by searching "SuperTank" on App Store',
	216: 'Android Download',
	217: 'iOS Download',
	218: 'Please scan QR code with your phone to download',
	// PC Index footer
	219: 'Lcent Computer Systems Co., Limited',
	// Login page
	220: 'Please enter your account',
	221: 'Please enter your password',
	222: '← Back to Home',
	223: 'Click here to download APK',
	224: 'Preview',
	225: 'Insufficient balance',
	226: 'insufficient, need',
	227: 'Change gender requires',
	// Download page game description
	228: 'SuperTank - Drive the steel beast and conquer the world!\n\nPowerful tanks, free assembly\nFrom classic tanks to high-tech war machines, choose from a variety of unique tank armor designs! Freely combine firepower, armor, and mobility to build your SuperTank and become invincible on the battlefield!\n\nHardcore controls, show your skills\nPrecise aiming and flexible positioning, tactical evasion... Every match is the ultimate test of skill and strategy! Single or team combat, crush your opponents and top the world rankings!\n\nDeep upgrades, strategy is king\nFrom cannons to engines, every part can be strengthened! Combine different skills and equipment to develop unique tactics, build an invincible tank army and conquer all challenges!\n\nGlobal real-time battles\nCompete with players from around the world and show off your SuperTank! Multiple modes for thrilling combat!\n\nDownload now and start your steel journey!\nIn the world of SuperTank, every shell writes your legend — will you be a ruler or cannon fodder? The choice is yours!',
	// ErrorCode
	1000: 'Success',
	1001: 'Failure',
	1002: 'Username does not conform to rules',
	1003: 'Password does not conform to rules',
	1004: 'Email does not conform to rules',
	1005: 'Not joined any team',
	1006: 'ID number does not conform to rules',
	1007: 'Username already exists',
	1008: 'Username is incorrect',
	1009: 'Password is incorrect',
	1010: 'Account has been locked',
	1011: 'Gender does not conform to rules',
	1012: 'Already joined a team',
	1013: 'Already applied to a team',
	1014: 'Bronze badge or above is required to create a team',
	1015: 'Team name already exists',
	1016: 'Team does not exist',
	1017: 'Not joined a team',
	1018: 'Only the team leader can review applications',
	1019: 'Not a member of this team, cannot view the list',
	1020: 'Team name is incorrect',
	1021: 'No team application form found',
	1022: 'Order is incorrect',
	1023: 'Incorrect amount of gold coins; creating a team requires 3000 gold coins',
	1024: 'Invitation code is incorrect',
	1025: 'Invitation code has been used',
	1026: 'Team leader cannot be removed',
	1027: 'Unknown error',
	1028: 'No access permission',
	1029: 'Nickname is incorrect',
	1030: 'Nickname already exists',
	1031: 'Nickname does not meet the rules',
	1032: 'Incorrect gold coin quantity',
	1033: 'Incorrect start time',
	1034: 'Incorrect end time',
	1035: 'Incorrect gold coin',
	1036: 'Incorrect QR code type',
	1037: 'Incorrect QR code',
	1038: 'Incorrect captcha',
	1039: 'Incorrect email',
	1040: 'Exceeded daily reset limit',
	1041: 'Incorrect score',
	1042: 'Incorrect receipt',
	1043: 'Incorrect gift type',
	1044: 'Incorrect product quantity',
	1045: 'Incorrect terminal type',
	1046: 'Incorrect payment method',
	1047: 'Incorrect tier',
	1048: 'Incorrect Steam ID',
	1049: 'PayPal order creation failed',
	1050: 'Steam order creation failed',
	1051: 'Authorization verification failed',
	1052: 'Authorization decoding failed',
	1053: 'Email verification code sent',
	1054: 'Email verification code requested too frequently',
	1055: 'Incorrect email verification code',
	1056: 'This email address has been blacklisted.',
	1057: 'Discord not configured',
	1058: 'Discord API request failed',
	1059: 'Failed to fetch Discord news',
	1060: 'Discord Announcements',
	1061: 'Alipay QR Code Recharge',
	1062: 'QR code recharge in progress, please wait...',
	1063: 'Close',
	1064: 'Back to Home',
	1065: 'Username (not forum account)',
	1066: 'Password',
	1067: 'SuperTank',
	1068: 'Click here to send me a message',
}

export default {
	...en,

	1069: 'Loading...',
	1070: 'No more items',
	1071: 'No news yet',

	1072: 'Rankings',
	1073: 'No ranking data yet',
}